/**
 * Centralized Category Grading Configuration
 * 
 * This file defines the grade categories, annotation codes, and colors
 * for each grading category in the system.
 */

export const CATEGORY_GRADE_CONFIG = {
  // A-Level Spanish
  'Alevel_Spanish_AQA_Texts': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Grammar, syntax, vocabulary accuracy, and complexity of language structures.' },
      { name: 'content', code: 'C', color: '#e74c3c', description: 'Critical analysis of themes, characters, techniques; depth of understanding and insight.' }
    ]
  },
  'Alevel_Spanish_AQA_Films': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Grammar, syntax, vocabulary accuracy, and complexity of language structures.' },
      { name: 'content', code: 'C', color: '#e74c3c', description: 'Critical analysis of themes, characters, techniques; depth of understanding and insight.' }
    ]
  },
  
  // A-Level French
  'Alevel_French_AQA_Texts': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Grammar, syntax, vocabulary accuracy, and complexity of language structures.' },
      { name: 'content', code: 'C', color: '#e74c3c', description: 'Critical analysis of themes, characters, techniques; depth of understanding and insight.' }
    ]
  },
  'Alevel_French_AQA_Films': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Grammar, syntax, vocabulary accuracy, and complexity of language structures.' },
      { name: 'content', code: 'C', color: '#e74c3c', description: 'Critical analysis of themes, characters, techniques; depth of understanding and insight.' }
    ]
  },
  
  // A-Level German
  'Alevel_German_AQA_Texts': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Grammar, syntax, vocabulary accuracy, and complexity of language structures.' },
      { name: 'content', code: 'C', color: '#e74c3c', description: 'Critical analysis of themes, characters, techniques; depth of understanding and insight.' }
    ]
  },
  'Alevel_German_AQA_Films': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Grammar, syntax, vocabulary accuracy, and complexity of language structures.' },
      { name: 'content', code: 'C', color: '#e74c3c', description: 'Critical analysis of themes, characters, techniques; depth of understanding and insight.' }
    ]
  },
  
  // A-Level Psychology
  'Alevel_Psych_AQA_16Mark': {
    gradeCategories: [
      { name: 'knowledge', code: 'K', color: '#27ae60', description: 'Demonstration of relevant knowledge and understanding of the subject matter.' },
      { name: 'application', code: 'A', color: '#e74c3c', description: 'Application of knowledge to the specific question or scenario.' },
      { name: 'evaluation', code: 'E', color: '#3498db', description: 'Critical evaluation and analysis of theories, studies, and concepts.' },
      { name: 'methodology', code: 'M', color: '#f39c12', description: 'Understanding of research methods and their applications.' }
    ]
  },
  
  // GCSE English Language
  'GCSE_EngLang_AQA_P1_Q5': {
    gradeCategories: [
      { name: 'content and organisation', code: 'AO5', color: '#3498db', description: 'Content & Organisation: responding to question, appropriate tone/register, coherent structure.' },
      { name: 'technical accuracy', code: 'AO6', color: '#e74c3c', description: 'Technical Accuracy: grammar, punctuation, spelling, vocabulary range.' }
    ]
  },
  'GCSE_EngLang_AQA_P2_Q5': {
    gradeCategories: [
      { name: 'content and organisation', code: 'AO5', color: '#3498db', description: 'Content & Organisation: responding to question, appropriate tone/register, coherent structure.' },
      { name: 'technical accuracy', code: 'AO6', color: '#e74c3c', description: 'Technical Accuracy: grammar, punctuation, spelling, vocabulary range.' }
    ]
  },
  
  // A-Level English Literature
  'Alevel_EngLitA_AQA_Love': {
    gradeCategories: [
      { name: 'argument & expression', code: 'AO1', color: '#e74c3c', description: 'Argument & Expression: responding to question, thesis, structure, personal response, quotations.' },
      { name: 'form & language', code: 'AO2', color: '#3498db', description: 'Form & Language: technical vocabulary, performance choices, form/structure analysis.' },
      { name: 'contexts', code: 'AO3', color: '#f39c12', description: 'Contexts: historical/social context, changing attitudes, dramatic form influence.' },
      { name: 'connections', code: 'AO4', color: '#27ae60', description: 'Connections: links between texts, similar relationships/emotions across texts.' },
      { name: 'interpretations', code: 'AO5', color: '#9b59b6', description: 'Interpretations: critics quotes, theoretical approaches, stage/screen productions.' }
    ]
  },
  'Alevel_EngLitB_AQA_Literary': {
    gradeCategories: [
      { name: 'argument & expression', code: 'AO1', color: '#e74c3c', description: 'Argument & Expression: responding to question, thesis, structure, personal response, quotations.' },
      { name: 'form & language', code: 'AO2', color: '#3498db', description: 'Form & Language: technical vocabulary, performance choices, form/structure analysis.' },
      { name: 'contexts', code: 'AO3', color: '#f39c12', description: 'Contexts: historical/social context, changing attitudes, dramatic form influence.' },
      { name: 'connections', code: 'AO4', color: '#27ae60', description: 'Connections: links between texts, similar relationships/emotions across texts.' },
      { name: 'interpretations', code: 'AO5', color: '#9b59b6', description: 'Interpretations: critics quotes, theoretical approaches, stage/screen productions.' }
    ]
  },
  
  // VCE English
  'VCE_English_SectionA': {
    gradeCategories: [
      { name: 'knowledge', code: 'K', color: '#27ae60', description: 'Understanding of texts, themes, and literary elements.' },
      { name: 'coherence', code: 'C', color: '#9b59b6', description: 'Logical structure, clear connections between ideas.' },
      { name: 'evidence', code: 'E', color: '#e74c3c', description: 'Relevant quotes and examples from texts.' },
      { name: 'language', code: 'L', color: '#3498db', description: 'Clarity, sophistication, and appropriateness of expression.' }
    ]
  },
  'VCE_English_SectionC': {
    gradeCategories: [
      { name: 'knowledge', code: 'K', color: '#27ae60', description: 'Understanding of texts, themes, and literary elements.' },
      { name: 'coherence', code: 'C', color: '#9b59b6', description: 'Logical structure, clear connections between ideas.' },
      { name: 'evidence', code: 'E', color: '#e74c3c', description: 'Relevant quotes and examples from texts.' },
      { name: 'language', code: 'L', color: '#3498db', description: 'Clarity, sophistication, and appropriateness of expression.' }
    ]
  },
  'VCE_English_SectionB': {
    gradeCategories: [
      { name: 'engagement', code: 'E', color: '#e67e22', description: 'Creative and thoughtful response to the prompt.' },
      { name: 'purpose', code: 'P', color: '#2ecc71', description: 'Clear intention and effective communication of ideas.' },
      { name: 'structure', code: 'S', color: '#9b59b6', description: 'Organized presentation, logical flow of ideas.' },
      { name: 'language', code: 'L', color: '#3498db', description: 'Expressive, varied, and appropriate language choices.' }
    ]
  },
  
  // Australian HSC
  'Australian_HSC': {
    gradeCategories: [
      { name: 'engagement', code: 'E', color: '#e67e22', description: 'Directly addresses the question, references all parts, and demonstrates thoughtful engagement with the topic.' },
      { name: 'structure', code: 'S', color: '#9b59b6', description: 'Clear essay structure, logical flow, effective use of paragraphs, introduction, and conclusion.' },
      { name: 'analysis', code: 'A', color: '#e74c3c', description: 'Depth of analysis, use of evidence, critical thinking, and insight into the texts or issues.' },
      { name: 'language', code: 'L', color: '#3498db', description: 'Clarity, accuracy, and sophistication of language, grammar, and vocabulary.' }
    ]
  },

  // Irish Aiste
  'Aiste': {
    gradeCategories: [
      { name: 'gaeilge', code: 'G', color: '#16a085', description: 'Proficiency in Irish: fluency, grammar, verb tenses, spelling, lenition, eclipsis.' },
      { name: 'content', code: 'C', color: '#c0392b', description: 'Engagement with title, clear and relevant ideas, opinions, storytelling.' },
      { name: 'style', code: 'S', color: '#8e44ad', description: 'Appropriate genre usage (essay, article, debate, speech).' }
    ]
  },

  // Grammar Checker
  'Grammar Checker': {
    gradeCategories: [
      { name: 'gaeilge', code: 'G', color: '#16a085', description: 'Gaeilge: Irish grammar and spelling rules, fluency, grammar, verb tenses, spelling, lenition, eclipsis.' }
    ]
  },

  // Irish Oral Exam
  'IE_Oral': {
    gradeCategories: [
      { name: 'gaeilge', code: 'G', color: '#16a085', description: 'Gaeilge: Irish grammar and spelling errors, fluency, grammar, verb tenses, spelling, lenition, eclipsis.' },
      { name: 'content', code: 'C', color: '#c0392b', description: 'Content: addressing question topics, making suggestions for additional material.' }
    ]
  },

  // English Comparative
  'Comparative': {
    gradeCategories: [
      { name: 'purpose', code: 'P', color: '#2ecc71', description: 'Clear understanding and engagement with the purpose and audience of the task.' },
      { name: 'coherence', code: 'C', color: '#e74c3c', description: 'Logical structure, clear progression of ideas, and effective organization.' },
      { name: 'language_use', code: 'L', color: '#3498db', description: 'Suitability of tone, style, varied vocabulary, and effective expression.' },
      { name: 'accuracy_of_mechanics', code: 'M', color: '#f1c40f', description: 'Punctuation, spelling, syntax, and technical accuracy.' }
    ]
  },

  // English Composition
  'Composition': {
    gradeCategories: [
      { name: 'purpose', code: 'P', color: '#2ecc71', description: 'Clear understanding and engagement with the purpose and audience of the task.' },
      { name: 'coherence', code: 'C', color: '#e74c3c', description: 'Logical structure, clear progression of ideas, and effective organization.' },
      { name: 'language_use', code: 'L', color: '#3498db', description: 'Suitability of tone, style, varied vocabulary, and effective expression.' },
      { name: 'mechanics', code: 'M', color: '#f1c40f', description: 'Punctuation, spelling, syntax, and technical accuracy.' }
    ]
  },

  // English Poetry
  'Poetry': {
    gradeCategories: [
      { name: 'purpose', code: 'P', color: '#2ecc71', description: 'Purpose: relevance to question, clear aim, original points, personal response (if required).' },
      { name: 'coherence', code: 'C', color: '#e74c3c', description: 'Coherence: logical flow, focused argument, integrated quotes, introduction/conclusion.' },
      { name: 'language', code: 'L', color: '#3498db', description: 'Language: formal register, clear expression, varied phrasing, interesting vocabulary.' },
      { name: 'mechanics', code: 'M', color: '#f1c40f', description: 'Mechanics: grammar, punctuation, capitalisation, syntax, British English adherence.' }
    ]
  },

  // English Shakespeare (General)
  'Shakespeare': {
    gradeCategories: [
      { name: 'purpose', code: 'P', color: '#2ecc71', description: 'Purpose: relevance to question, clear aim, original points, personal response.' },
      { name: 'coherence', code: 'C', color: '#e74c3c', description: 'Coherence: logical flow, focused argument, integrated quotes, introduction/conclusion.' },
      { name: 'language_use', code: 'L', color: '#3498db', description: 'Language Use: formal register, clear expression, varied phrasing, interesting vocabulary.' },
      { name: 'accuracy_of_mechanics', code: 'M', color: '#f1c40f', description: 'Accuracy of Mechanics: grammar, punctuation, capitalisation, syntax.' }
    ]
  },

  // GCSE English Literature - Shakespeare
  'GCSE_Shakespeare': {
    gradeCategories: [
      { name: 'argument', code: 'AO1', color: '#9b59b6', description: 'Clear thesis, well-developed arguments, textual evidence.' },
      { name: 'language', code: 'AO2', color: '#3498db', description: 'Analysis of language techniques, dramatic devices, and structure.' },
      { name: 'context', code: 'AO3', color: '#f39c12', description: 'Relevant historical, social, and literary context connected to the text.' },
      { name: 'mechanics', code: 'AO4', color: '#e74c3c', description: 'Accurate spelling, punctuation, and varied sentence structure.' }
    ]
  },

  // Filiocht (Irish Poetry)
  'Filiocht_I': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#c0392b', description: 'Understanding and analysis of poetic content and themes.' },
      { name: 'gaeilge', code: 'G', color: '#16a085', description: 'Proficiency in Irish language usage and expression.' }
    ]
  },
  'Filiocht_II': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#c0392b', description: 'Understanding and analysis of poetic content and themes.' },
      { name: 'gaeilge', code: 'G', color: '#16a085', description: 'Proficiency in Irish language usage and expression.' }
    ]
  },
  'Filiocht_III': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#c0392b', description: 'Understanding and analysis of poetic content and themes.' },
      { name: 'gaeilge', code: 'G', color: '#16a085', description: 'Proficiency in Irish language usage and expression.' }
    ]
  },

  // GCSE English Literature - 19th Century Novel
  'GCSE_19th': {
    gradeCategories: [
      { name: 'argument', code: 'AO1', color: '#9b59b6', description: 'Clear thesis, well-developed arguments, textual evidence.' },
      { name: 'language', code: 'AO2', color: '#3498db', description: 'Analysis of language techniques, dramatic devices, and structure.' },
      { name: 'context', code: 'AO3', color: '#f39c12', description: 'Relevant historical, social, and literary context connected to the text.' },
      { name: 'mechanics', code: 'AO4', color: '#e74c3c', description: 'Accurate spelling, punctuation, and varied sentence structure.' }
    ]
  },

  // GCSE English Literature - Modern Text
  'GCSE_Inspector': {
    gradeCategories: [
      { name: 'argument', code: 'AO1', color: '#9b59b6', description: 'Clear thesis, well-developed arguments, textual evidence.' },
      { name: 'language', code: 'AO2', color: '#3498db', description: 'Analysis of language techniques, dramatic devices, and structure.' },
      { name: 'context', code: 'AO3', color: '#f39c12', description: 'Relevant historical, social, and literary context connected to the text.' },
      { name: 'mechanics', code: 'AO4', color: '#e74c3c', description: 'Accurate spelling, punctuation, and varied sentence structure.' }
    ]
  },

  // GCSE English Literature - Poetry
  'GCSE_Poetry': {
    gradeCategories: [
      { name: 'argument', code: 'AO1', color: '#9b59b6', description: 'Clear thesis, well-developed arguments, textual evidence.' },
      { name: 'language', code: 'AO2', color: '#3498db', description: 'Analysis of language techniques, dramatic devices, and structure.' },
      { name: 'context', code: 'AO3', color: '#f39c12', description: 'Relevant historical, social, and literary context connected to the text.' }
    ]
  },

  // GCSE French
  'GCSE_French_Q1': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#f39c12', description: 'Content: answering bullet points, expressing opinions, clarity of information.' },
      { name: 'language', code: 'L', color: '#3498db', description: 'Language: vocabulary variety, sentence complexity, time frames, accuracy.' }
    ]
  },
  'GCSE_French_Q2': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#f39c12', description: 'Content: answering bullet points, expressing and justifying opinions.' },
      { name: 'range_of_language', code: 'L', color: '#3498db', description: 'Range of Language: vocabulary variety, structure complexity, fluency, style/register.' },
      { name: 'accuracy', code: 'A', color: '#e74c3c', description: 'Accuracy: grammar, spelling, verb/tense formations, time frames.' }
    ]
  },

  // GCSE French Grammar
  'GCSE_FR_Grammar': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Language: idiomatic French, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },

  // French Grammar (General)
  'FR_Grammar': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Language: idiomatic French, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },

  // General French
  'FR_Oral': {
    gradeCategories: [
      { name: 'communication', code: 'C', color: '#FF6B6B', description: 'Communication: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic French, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'FR_Diary': {
    gradeCategories: [
      { name: 'communication', code: 'C', color: '#FF6B6B', description: 'Communication: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic French, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'FR_Opinion': {
    gradeCategories: [
      { name: 'communication', code: 'C', color: '#FF6B6B', description: 'Communication: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic French, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'FR_Email': {
    gradeCategories: [
      { name: 'communication', code: 'C', color: '#FF6B6B', description: 'Communication: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic French, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'FR_Recit': {
    gradeCategories: [
      { name: 'communication', code: 'C', color: '#FF6B6B', description: 'Communication: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic French, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'prompt_french_json': {
    gradeCategories: [
      { name: 'communication', code: 'C', color: '#FF6B6B', description: 'Communication: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic French, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },

  // German GCSE
  'GCSE_German_Q1': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#f39c12', description: 'Content: answering bullet points, expressing opinions, clarity of information.' },
      { name: 'language', code: 'L', color: '#3498db', description: 'Language: vocabulary variety, sentence complexity, time frames, accuracy.' }
    ]
  },

  // German GCSE Question 2
  'GCSE_German_Q2': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#f39c12', description: 'Content: answering bullet points, expressing and justifying opinions.' },
      { name: 'range_of_language', code: 'L', color: '#3498db', description: 'Range of Language: vocabulary variety, structure complexity, fluency, style/register.' },
      { name: 'accuracy', code: 'A', color: '#e74c3c', description: 'Accuracy: grammar, spelling, verb/tense formations, time frames.' }
    ]
  },

  // German GCSE Grammar
  'GCSE_DE_Grammar': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Language: idiomatic German, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },

  // German Grammar (General)
  'DE_Grammar': {
    gradeCategories: [
      { name: 'expression', code: 'E', color: '#3498db', description: 'Expression: idiomatic German, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },

  // General German
  'DE_Oral': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#2ecc71', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'expression', code: 'E', color: '#3498db', description: 'Expression: idiomatic German, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'DE_Ausserung': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#2ecc71', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'expression', code: 'E', color: '#3498db', description: 'Expression: idiomatic German, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'DE_Letter': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#2ecc71', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'expression', code: 'E', color: '#3498db', description: 'Expression: idiomatic German, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'DE_TopicalQuestions': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#2ecc71', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'expression', code: 'E', color: '#3498db', description: 'Expression: idiomatic German, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'prompt_german_json': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#2ecc71', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'expression', code: 'E', color: '#3498db', description: 'Expression: idiomatic German, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },

  // Spanish GCSE Question 1
  'GCSE_Spanish_Q1': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#f39c12', description: 'Content: answering bullet points, expressing opinions, clarity of information.' },
      { name: 'language', code: 'L', color: '#3498db', description: 'Language: vocabulary variety, sentence complexity, time frames, accuracy.' }
    ]
  },

  // Spanish GCSE Question 2
  'GCSE_Spanish_Q2': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#f39c12', description: 'Content: answering bullet points, expressing and justifying opinions.' },
      { name: 'range_of_language', code: 'L', color: '#3498db', description: 'Range of Language: vocabulary variety, structure complexity, fluency, style/register.' },
      { name: 'accuracy', code: 'A', color: '#e74c3c', description: 'Accuracy: grammar, spelling, verb/tense formations, time frames.' }
    ]
  },

  // Spanish GCSE Grammar
  'GCSE_ES_Grammar': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Language: idiomatic Spanish, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },

  // Spanish Grammar (General)
  'ES_Grammar': {
    gradeCategories: [
      { name: 'language', code: 'L', color: '#3498db', description: 'Language: idiomatic Spanish, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },

  // General Spanish
  'ES_Oral': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#FF6B6B', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic Spanish, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'ES_Opinion': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#FF6B6B', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic Spanish, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'ES_LetterEmail': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#FF6B6B', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic Spanish, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'ES_Diary': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#FF6B6B', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic Spanish, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'ES_Note': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#FF6B6B', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic Spanish, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  },
  'prompt_spanish_json': {
    gradeCategories: [
      { name: 'content', code: 'C', color: '#FF6B6B', description: 'Content: engagement with content, textual coherence, clarity of argument, appropriate register.' },
      { name: 'language', code: 'L', color: '#4ECDC4', description: 'Language: idiomatic Spanish, rich vocabulary, complex sentences, correct verb/noun agreement, spelling.' }
    ]
  }
};

/**
 * Get the grade configuration for a specific category
 */
export function getCategoryGradeConfig(category) {
  return CATEGORY_GRADE_CONFIG[category] || null;
}

/**
 * Get color map for annotation codes based on category
 */
export function getColorMapFromConfig(category) {
  const config = getCategoryGradeConfig(category);
  if (!config) return null;
  
  const colorMap = {};
  config.gradeCategories.forEach(grade => {
    colorMap[grade.code] = grade.color;
  });
  
  return colorMap;
}

/**
 * Get valid annotation codes for a category
 */
export function getValidCodesFromConfig(category) {
  const config = getCategoryGradeConfig(category);
  if (!config) return null;
  
  const codes = config.gradeCategories.map(grade => grade.code).join('');
  return `[${codes}]`;
}

/**
 * Map grade category name to its corresponding annotation code and color
 */
export function mapGradeCategoryToAnnotation(category, gradeCategoryName) {
  const config = getCategoryGradeConfig(category);
  if (!config) return null;
  
  const gradeCategory = config.gradeCategories.find(
    grade => grade.name.toLowerCase() === gradeCategoryName.toLowerCase()
  );
  
  return gradeCategory ? {
    code: gradeCategory.code,
    color: gradeCategory.color,
    description: gradeCategory.description
  } : null;
} 